module.exports = __webpack_public_path__ + "img/export_office1.aa0f25b6.png";